import type {
  Product,
  ProductListingStats,
  PurchaseOption,
} from "@/types/products";

function parsePrice(value: string | null | undefined): number | null {
  if (value == null || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

function pricesFrom(options: PurchaseOption[]): number[] {
  const prices: number[] = [];
  for (const opt of options) {
    const price = parsePrice(opt.current_price);
    if (price != null) prices.push(price);
  }
  return prices;
}

/**
 * Derive availability and price range from purchase_options.
 * The search/product APIs do not include has_available_variants / min_price / max_price.
 */
export function deriveProductListingStats(
  product: Product,
): ProductListingStats {
  const options = product.purchase_options ?? [];
  const has_available_variants = options.some((o) => o.is_in_stock === true);

  const inStock = options.filter((o) => o.is_in_stock === true);
  const priced = pricesFrom(inStock.length > 0 ? inStock : options);

  return {
    has_available_variants,
    min_price: priced.length > 0 ? Math.min(...priced) : null,
    max_price: priced.length > 0 ? Math.max(...priced) : null,
    variant_count: options.length,
  };
}
